import React from 'react';
import Pantalla3 from '../Pantalla3/Pantalla3';
import Footer from '../../Footer/Footer';

function PantallaBase3() {

    return (
        <>
            <div className='initBack_P2 animate__animated animate__fadeIn'>
                <div className='containerRender'>
                    <Pantalla3 />
                </div>
                <Footer />
            </div>
        </>
    )
}

export default PantallaBase3
